import { clsx } from 'clsx';
import { Icon } from './Icon';

type Props = {
  icon: string;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
};

export function AiChip({ icon, children, onClick, className }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'flex items-center gap-2 w-full text-left',
        'px-3 py-2 rounded-[7px] text-[12px]',
        'bg-[rgba(167,139,250,0.15)] border border-[rgba(167,139,250,0.2)]',
        'hover:bg-[rgba(167,139,250,0.22)] hover:border-[rgba(167,139,250,0.45)]',
        'hover:translate-x-0.5 transition-all',
        'text-text',
        className,
      )}
    >
      <Icon name={icon} size={14} className="flex-shrink-0 text-ai" />
      <span>{children}</span>
    </button>
  );
}
